import type { FlightFragment } from '@websky/graphql';

export const getFlightSegmentIds = (flight?: FlightFragment | null): string[] =>
	flight?.segments?.reduce<string[]>((segmentIds, segment) => {
		if (segment?.segment?.id) {
			segmentIds.push(segment.segment.id);
		}

		return segmentIds;
	}, []) ?? [];
